/* ==========================================================================
   Exin — Offertverktyg (internt)
   Offert-PDF i Visma-layout med produktbilder. Sektion: sections/exin-offertverktyg.liquid
   PDF: jsPDF + Funnel Sans (assets/exin-quote-jspdf*.js). Utkast i localStorage.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('ExinOffertverktyg');
  if (!root) return;

  var DRAFT_KEY = 'exin:offertverktyg:draft';
  var AUTH_KEY = 'exin:offertverktyg:auth';

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var cfg = function (k) { return root.getAttribute('data-' + k) || ''; };

  /* ---------- hjälpare ---------- */
  function readJSON(k) { try { var s = localStorage.getItem(k); return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function writeJSON(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.'));
    return isFinite(n) ? n : 0;
  }
  function plain(s) { return String(s).replace(/[  ]/g, ' '); }
  // 8 900 / 8 900,50 (decimaler bara när de finns)
  function kr(n) {
    var r = Math.round(n * 100) / 100;
    return plain(r.toLocaleString('sv-SE', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 }));
  }
  function kr2(n) { return plain((Math.round(n * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }
  function isoDate(d) {
    var p = function (x) { return (x < 10 ? '0' : '') + x; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function uid() { return Math.random().toString(36).slice(2, 10); }
  // cdn.shopify.com/s/files/…/files/x.jpg → /cdn/shop/files/x.jpg (samma domän → kan bäddas in i PDF)
  function sameOriginImg(src, width) {
    if (!src) return '';
    var s = String(src).replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/[\d\/]+\/files\//, '/cdn/shop/files/')
      .replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    if (width) s += (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    return s;
  }
  function rowSum(r) { return num(r.qty) * num(r.price) * (1 - Math.min(100, Math.max(0, num(r.disc))) / 100); }

  var toastTimer = null;
  function toast(msg) {
    var t = $('[data-eov-toast]');
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.hidden = true; }, 250); }, 2600);
  }

  /* ---------- lösenord ---------- */
  function sha256(text) {
    var data = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', data).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return (b < 16 ? '0' : '') + b.toString(16); }).join('');
    });
  }
  function showTool() {
    var hubEl = $('[data-eov-hub]');
    if (hubEl) hubEl.hidden = true;
    $('[data-eov-app]').hidden = false;
    init();
  }
  function showHub() {
    $('[data-eov-app]').hidden = true;
    $('[data-eov-hub]').hidden = false;
    window.scrollTo(0, 0);
  }
  function unlock() {
    // Markerar att inloggningen är kontrollerad (Workspace Studio använder det för att öppna direkt)
    try { localStorage.setItem('exin:internt:verified', cfg('pass')); } catch (err) {}
    $('[data-eov-gate]').hidden = true;
    // Direkt till verktyget om man kommer från en länk i förfrågningsmejlet (#exqt=…) eller om
    // menyn av någon anledning saknas -- annars visas menyn där man väljer verktyg.
    if (!$('[data-eov-hub]') || window.__exqtLinkData) { showTool(); return; }
    showHub();
  }
  root.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-eov-open]')) { e.preventDefault(); showTool(); return; }
    if (t.closest('[data-eov-menu]')) { showHub(); return; }
    if (t.closest('[data-eov-logout]')) {
      try { localStorage.removeItem(AUTH_KEY); localStorage.removeItem('exin:internt:verified'); } catch (err) {}
      location.reload();
    }
  });
  (function gate() {
    var expected = cfg('pass');
    var emptyHash = 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
    if (!expected || expected === emptyHash) {
      $('[data-eov-gate-err]').textContent = 'Inloggningen är inte konfigurerad ännu.';
      $('[data-eov-gate-err]').hidden = false;
      $('[data-eov-gate-form] button').disabled = true;
      return;
    }
    var saved = null;
    try { saved = localStorage.getItem(AUTH_KEY); } catch (e) {}
    if (saved === expected) { unlock(); return; }
    $('[data-eov-gate-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      sha256($('[data-eov-gate-input]').value.trim()).then(function (h) {
        if (h === expected) {
          try { localStorage.setItem(AUTH_KEY, h); } catch (err) {}
          unlock();
        } else {
          $('[data-eov-gate-err]').hidden = false;
          $('[data-eov-gate-input]').select();
        }
      });
    });
    setTimeout(function () { $('[data-eov-gate-input]').focus(); }, 50);
  })();

  /* ---------- tillstånd ---------- */
  var state;
  function defaults() {
    var today = new Date();
    var valid = new Date(today.getTime() + (parseInt(cfg('valid-days'), 10) || 14) * 86400000);
    return {
      f: {
        nr: '', date: isoDate(today), kundnr: '', varRef: '', erRef: '', kundref: '', info: '',
        villkor: cfg('terms') || '30 dgr netto', giltig: isoDate(valid),
        lev0: '', lev1: '', lev2: '', lev3: 'Sverige', kop0: '', kop1: '', kop2: '', kop3: 'Sverige', sameAddr: false
      },
      rows: []
    };
  }
  function save() { writeJSON(DRAFT_KEY, state); }

  function sellers() {
    return cfg('sellers').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /* ---------- formulärfält ---------- */
  function fillFields() {
    $$('[data-f]').forEach(function (el) {
      var k = el.getAttribute('data-f');
      if (el.type === 'checkbox') el.checked = !!state.f[k];
      else el.value = state.f[k] == null ? '' : state.f[k];
    });
    syncBuyer();
  }
  function syncBuyer() {
    var same = !!state.f.sameAddr;
    $('[data-eov-buyer]').classList.toggle('is-disabled', same);
    $$('[data-eov-buyer] input').forEach(function (el) { el.disabled = same; });
    if (same) {
      for (var i = 0; i < 4; i++) {
        state.f['kop' + i] = state.f['lev' + i];
        var inp = $('[data-f="kop' + i + '"]');
        if (inp) inp.value = state.f['kop' + i];
      }
    }
  }

  /* ---------- rader ---------- */
  function rowHTML(r, i, n) {
    return (
      '<div class="eov-row" data-id="' + r.id + '">' +
        '<div class="eov-row__img">' +
          (r.img ? '<img src="' + esc(sameOriginImg(r.img, 160)) + '" alt="" loading="lazy">' : '<span>Egen rad</span>') +
        '</div>' +
        '<div class="eov-row__text">' +
          '<input class="eov-input eov-row__title" data-r="title" value="' + esc(r.title) + '" placeholder="Benämning" aria-label="Benämning">' +
          '<textarea class="eov-input eov-row__desc" data-r="desc" rows="' + Math.max(1, (r.desc || '').split('\n').length) + '" placeholder="Beskrivning (valfritt, en rad per rad)" aria-label="Beskrivning">' + esc(r.desc) + '</textarea>' +
        '</div>' +
        '<input class="eov-input eov-num" data-r="qty" inputmode="decimal" value="' + esc(r.qty) + '" aria-label="Antal">' +
        '<input class="eov-input" data-r="unit" value="' + esc(r.unit) + '" aria-label="Enhet">' +
        '<input class="eov-input eov-num" data-r="price" inputmode="decimal" value="' + esc(r.price) + '" aria-label="à pris">' +
        '<input class="eov-input eov-num" data-r="disc" inputmode="decimal" value="' + esc(r.disc || '') + '" placeholder="0" aria-label="Rabatt i procent">' +
        '<div class="eov-row__sum" data-r-sum>' + kr(rowSum(r)) + '</div>' +
        '<div class="eov-row__tools">' +
          '<button type="button" data-eov-move="-1" aria-label="Flytta upp"' + (i === 0 ? ' disabled' : '') + '>↑</button>' +
          '<button type="button" data-eov-move="1" aria-label="Flytta ned"' + (i === n - 1 ? ' disabled' : '') + '>↓</button>' +
          '<button type="button" data-eov-del aria-label="Ta bort rad">✕</button>' +
        '</div>' +
      '</div>'
    );
  }
  function renderRows() {
    var n = state.rows.length;
    $('[data-eov-rows]').innerHTML = state.rows.map(function (r, i) { return rowHTML(r, i, n); }).join('');
    $('[data-eov-empty]').hidden = n > 0;
    renderTotals();
  }
  function renderTotals() {
    var sum = state.rows.reduce(function (s, r) { return s + rowSum(r); }, 0);
    $('[data-eov-sum]').textContent = kr2(sum) + ' kr';
    $('[data-eov-moms]').textContent = kr2(sum * 0.25) + ' kr';
    $('[data-eov-total]').textContent = kr2(sum * 1.25) + ' kr';
  }
  function findRow(el) {
    var rowEl = el.closest('.eov-row');
    if (!rowEl) return null;
    var id = rowEl.getAttribute('data-id');
    for (var i = 0; i < state.rows.length; i++) if (state.rows[i].id === id) return { row: state.rows[i], index: i, el: rowEl };
    return null;
  }
  function addRow(r) {
    state.rows.push(Object.assign({ id: uid(), img: '', title: '', desc: '', qty: 1, unit: 'st', price: 0, disc: '' }, r));
    save(); renderRows();
  }

  /* ---------- produktsök ---------- */
  var searchTimer = null, searchSeq = 0, lastResults = [];
  function doSearch(q) {
    var box = $('[data-eov-results]');
    if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    var seq = ++searchSeq;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== searchSeq) return;
        lastResults = (data.resources && data.resources.results && data.resources.results.products) || [];
        box.innerHTML = lastResults.length
          ? lastResults.map(function (p, i) {
              return '<button type="button" class="eov-hit" data-eov-hit="' + i + '">' +
                (p.image ? '<img src="' + esc(sameOriginImg(p.image, 120)) + '" alt="">' : '<span class="eov-hit__ph"></span>') +
                '<span class="eov-hit__title">' + esc(p.title) + '</span>' +
                '<span class="eov-hit__price">' + kr(num(p.price)) + ' kr</span>' +
              '</button>';
            }).join('')
          : '<p class="eov-hit__none">Inga produkter hittades.</p>';
        box.hidden = false;
      })
      .catch(function () { box.innerHTML = '<p class="eov-hit__none">Sökningen misslyckades. Försök igen.</p>'; box.hidden = false; });
  }
  function pickProduct(p) {
    var box = $('[data-eov-results]');
    var handleUrl = (p.url || ('/products/' + p.handle)).split('?')[0];
    box.innerHTML = '<p class="eov-hit__none">Hämtar ' + esc(p.title) + '…</p>';
    fetch(handleUrl + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var variants = prod.variants || [];
      var add = function (v) {
        var vt = v.title && v.title !== 'Default Title' ? v.title : '';
        var desc = [vt, v.sku ? 'Art.nr ' + v.sku : ''].filter(Boolean).join('\n');
        var img = (v.featured_image && v.featured_image.src) || prod.featured_image || p.image || '';
        addRow({ img: img, title: prod.title, desc: desc, qty: 1, unit: 'st', price: (v.price || 0) / 100, url: handleUrl + '?variant=' + v.id });
        box.hidden = true; box.innerHTML = '';
        $('[data-eov-search]').value = '';
        toast(prod.title + ' lades till');
      };
      if (variants.length <= 1) { add(variants[0] || { price: Math.round(num(p.price) * 100) }); return; }
      box.innerHTML = '<p class="eov-hit__label">Välj variant av ' + esc(prod.title) + ':</p>' +
        variants.map(function (v, i) {
          return '<button type="button" class="eov-hit eov-hit--variant" data-eov-variant="' + i + '">' +
            '<span class="eov-hit__title">' + esc(v.title) + (v.sku ? ' · ' + esc(v.sku) : '') + '</span>' +
            '<span class="eov-hit__price">' + kr(v.price / 100) + ' kr</span></button>';
        }).join('');
      box._variants = variants; box._add = add;
    }).catch(function () { box.innerHTML = '<p class="eov-hit__none">Kunde inte hämta produkten.</p>'; });
  }

  /* ---------- PDF ---------- */
  var jsPdfPromise = null;
  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url; s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Kunde inte ladda ' + url)); };
      document.head.appendChild(s);
    });
  }
  function loadJsPdf() {
    if (jsPdfPromise) return jsPdfPromise;
    var fontsLoaded = function () { return !!document.querySelector('script[src*="ews-jspdf-fonts"], script[src*="exin-quote-jspdf-fonts"]'); };
    jsPdfPromise = (window.jspdf && window.jspdf.jsPDF ? Promise.resolve() : loadScript(cfg('jspdf')))
      .then(function () { return fontsLoaded() ? null : loadScript(cfg('jspdf-fonts')); })
      .then(function () { return window.jspdf.jsPDF; });
    jsPdfPromise.catch(function () { jsPdfPromise = null; });
    return jsPdfPromise;
  }
  function imageData(src, maxPx) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var sc = Math.min(1, maxPx / Math.max(img.naturalWidth, img.naturalHeight));
          var w = Math.max(1, Math.round(img.naturalWidth * sc)), h = Math.max(1, Math.round(img.naturalHeight * sc));
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); ctx.drawImage(img, 0, 0, w, h);
          resolve({ data: c.toDataURL('image/jpeg', 0.9), w: w, h: h });
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function buildPdf() {
    var f = state.f, rows = state.rows;
    return Promise.all([
      loadJsPdf(),
      imageData(cfg('logo'), 700),
      Promise.all(rows.map(function (r) { return r.img ? imageData(sameOriginImg(r.img, 300), 300) : Promise.resolve(null); }))
    ]).then(function (res) {
      var JsPDF = res[0], logo = res[1], imgs = res[2];
      var doc = new JsPDF({ unit: 'mm', format: 'a4' });
      var F = doc.getFontList && doc.getFontList().FunnelSans ? 'FunnelSans' : 'helvetica';
      var ink = [17, 17, 17], muted = [110, 110, 110], lineC = [200, 200, 200], soft = [235, 230, 222];
      var L = 14, R = 196, W = R - L, MID = 105;
      var set = function (style, size, color) { doc.setFont(F, style); doc.setFontSize(size); doc.setTextColor.apply(doc, color || ink); };
      var box = function (x, y, w, h) { doc.setDrawColor.apply(doc, lineC); doc.setLineWidth(0.3); doc.roundedRect(x, y, w, h, 2, 2, 'S'); };
      var lbl = function (t, x, y, align) { set('normal', 7.5, muted); doc.text(t, x, y, align ? { align: align } : undefined); };
      var val = function (t, x, y, style, size) { set(style || 'normal', size || 9.5); doc.text(plain(t || ''), x, y); };
      var cQty = 128, cUnit = 133, cPrice = 160, cDisc = 172, cSum = R - 4;
      var page = 1;

      function header() {
        // Loggan: synlig del 7,7 mm från sidkanten och 7,7 mm ovanför adressrutorna (y=46)
        if (logo) doc.addImage(logo.data, 'JPEG', L + 4, 6.87, 40, 40 * logo.h / logo.w);
        box(MID, 10, R - MID, 13);
        set('bold', 18); doc.text('Offert', MID + 6, 19);
        set('bold', 11); doc.text(plain(f.nr || ''), MID + 34, 19);
        lbl('Sida', R - 22, 18); val(String(page), R - 14, 18);
        box(MID, 25, R - MID, 13);
        lbl('Datum', MID + 6, 30); val(f.date, MID + 6, 35);
        lbl('Kundnr', MID + 40, 30); val(f.kundnr, MID + 40, 35);
      }
      function footer() {
        var y = 262;
        box(L, y, W, 24);
        set('bold', 9); doc.text(plain(cfg('company')), L + 5, y + 6);
        set('normal', 7.5, muted); doc.text('Innehar F-skattebevis', R - 4, y + 6, { align: 'right' });
        var cols = [
          ['Postadress', [cfg('address1'), cfg('address2')]], ['Telefon', [cfg('phone')]], ['Bankgiro', [cfg('bankgiro')]],
          ['Org.nr', [cfg('orgnr')]], ['E-post', [cfg('email')]], ['Hemsida', [cfg('web')]]
        ];
        var colX = [0, 38, 66, 94, 122, 152];
        cols.forEach(function (c, i) {
          var x = L + 5 + colX[i];
          lbl(c[0], x, y + 12);
          set('normal', 8.5); c[1].filter(Boolean).forEach(function (t, k) { doc.text(plain(t), x, y + 16 + k * 3.8); });
        });
      }
      function tableHead(y) {
        box(L, y, W, 9);
        set('bold', 8.5, muted);
        doc.text('Benämning', L + 5, y + 5.8);
        doc.text('Antal', cQty, y + 5.8, { align: 'right' });
        doc.text('Enhet', cUnit, y + 5.8);
        doc.text('à pris', cPrice, y + 5.8, { align: 'right' });
        doc.text('Rabatt', cDisc, y + 5.8, { align: 'right' });
        doc.text('Belopp', cSum, y + 5.8, { align: 'right' });
        return y + 11;
      }

      // --- Sida 1: huvud, adresser, referenser
      header();
      var y = 46;
      box(L, y, MID - L - 3, 34); box(MID, y, R - MID, 34);
      lbl('Leveransadress', L + 5, y + 6);
      [f.lev0, f.lev1, f.lev2, f.lev3].forEach(function (t, i) { val(t, L + 5, y + 13 + i * 5.4, i === 0 ? 'bold' : 'normal', 11); });
      lbl('Köpare', MID + 6, y + 6);
      var kop = f.sameAddr ? [f.lev0, f.lev1, f.lev2, f.lev3] : [f.kop0, f.kop1, f.kop2, f.kop3];
      kop.forEach(function (t, i) { val(t, MID + 6, y + 13 + i * 5.4, i === 0 ? 'bold' : 'normal', 11); });
      y = 84;
      box(L, y, W, 22);
      lbl('Vår ref', L + 5, y + 6); val(f.varRef, L + 5, y + 10.5);
      lbl('Kundreferens', L + 50, y + 6); val(f.kundref, L + 50, y + 10.5);
      lbl('Betalningsvillkor', MID + 6, y + 6); val(f.villkor, MID + 6, y + 10.5);
      lbl('Er ref', L + 5, y + 15); val(f.erRef, L + 5, y + 19.5);
      lbl('Info', L + 50, y + 15); val(f.info, L + 50, y + 19.5);
      lbl('Offert är giltig t.o.m.', MID + 6, y + 15); val(f.giltig, MID + 6, y + 19.5);

      var bodyTop = tableHead(110);
      y = bodyTop + 5;
      var PAGE_LIMIT = 258, LAST_LIMIT = 236;

      function newPage() {
        box(L, bodyTop, W, PAGE_LIMIT - bodyTop);
        footer();
        doc.addPage(); page++;
        header();
        bodyTop = tableHead(46);
        y = bodyTop + 5;
      }

      // --- Rader
      var sum = 0;
      rows.forEach(function (r, idx) {
        var img = imgs[idx], hasImg = !!img;
        var tx = hasImg ? L + 25 : L + 5, tw = cQty - 12 - tx;
        set('bold', 9.5); var tl = doc.splitTextToSize(plain(r.title || ''), tw);
        set('normal', 8.5);
        var dl = String(r.desc || '').split('\n').filter(function (x) { return x.trim(); })
          .reduce(function (a, line) { return a.concat(doc.splitTextToSize(plain(line), tw)); }, []);
        var rowH = Math.max(hasImg ? 18 : 0, tl.length * 4.4 + dl.length * 3.9) + 4;
        if (y + rowH > PAGE_LIMIT) newPage();

        if (hasImg) {
          doc.setDrawColor.apply(doc, soft); doc.setLineWidth(0.2);
          doc.roundedRect(L + 5, y - 1, 17, 17, 1.5, 1.5, 'S');
          var s = 16, iw = img.w >= img.h ? s : s * img.w / img.h, ih = img.h >= img.w ? s : s * img.h / img.w;
          doc.addImage(img.data, 'JPEG', L + 5.5 + (s - iw) / 2, y - 0.5 + (s - ih) / 2, iw, ih);
        }
        var ty = y + 3;
        set('bold', 9.5); doc.text(tl, tx, ty); ty += tl.length * 4.4;
        if (dl.length) { set('normal', 8.5, muted); doc.text(dl, tx, ty); }

        var belopp = rowSum(r); sum += belopp;
        set('normal', 9.5);
        doc.text(kr(num(r.qty)), cQty, y + 3, { align: 'right' });
        doc.text(plain(r.unit || ''), cUnit, y + 3);
        doc.text(kr(num(r.price)), cPrice, y + 3, { align: 'right' });
        if (num(r.disc)) doc.text(kr(num(r.disc)) + ' %', cDisc, y + 3, { align: 'right' });
        set('bold', 9.5); doc.text(kr(belopp), cSum, y + 3, { align: 'right' });

        y += rowH;
        doc.setDrawColor.apply(doc, soft); doc.setLineWidth(0.2); doc.line(L + 5, y - 2, R - 4, y - 2);
        y += 2;
      });

      // Plats för text + summering på sista sidan?
      if (y > LAST_LIMIT - 8) newPage();
      box(L, bodyTop, W, LAST_LIMIT - bodyTop);
      set('normal', 8.5, muted); doc.text(plain(cfg('note')), L + 5, LAST_LIMIT - 4);

      // --- Summering
      y = LAST_LIMIT + 2;
      box(L, y, W, 20);
      lbl('Med vänlig hälsning', L + 5, y + 6); val(f.varRef, L + 5, y + 13, 'bold');
      var moms = sum * 0.25;
      lbl('Summa exkl. moms', 112, y + 6); set('bold', 11); doc.text(kr2(sum) + ' kr', 112, y + 13);
      lbl('Moms 25 %', 145, y + 6); set('normal', 10); doc.text(kr2(moms) + ' kr', 145, y + 13);
      lbl('Att betala inkl. moms', R - 4, y + 6, 'right'); set('bold', 11); doc.text(kr2(sum + moms) + ' kr', R - 4, y + 13, { align: 'right' });
      footer();

      doc.setProperties({ title: 'Offert ' + (f.nr || '') });
      return doc;
    });
  }
  function pdfName() { return 'Offert-' + (state.f.nr ? String(state.f.nr).replace(/[^\w\-]+/g, '') : 'utkast') + '.pdf'; }

  function withBusy(btn, fn) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Skapar PDF…';
    return fn().catch(function () { toast('Kunde inte skapa PDF. Försök igen.'); })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  }
  function checkReady() {
    if (!state.rows.length) { toast('Lägg till minst en rad först.'); return false; }
    return true;
  }
  function downloadPdf(btn) {
    if (!checkReady()) return;
    withBusy(btn, function () { return buildPdf().then(function (doc) { doc.save(pdfName()); }); });
  }
  // Mobil: inbäddad PDF (iframe) fungerar inte i Safari på iPhone/de flesta mobiler → visas svart.
  // Där öppnas PDF:en i en ny flik med telefonens egen PDF-visning i stället.
  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches && window.matchMedia('(max-width: 1024px)').matches);
  }
  function previewPdfMobile(btn) {
    // Fliken måste öppnas direkt i klicket (annars blockeras den), innehållet sätts när PDF:en är klar
    var w = window.open('', '_blank');
    if (w) {
      try { w.document.title = 'Skapar PDF…'; w.document.body.innerHTML = '<p style="font:16px sans-serif;padding:24px">Skapar PDF…</p>'; } catch (e) {}
    }
    withBusy(btn, function () {
      return buildPdf().then(function (doc) {
        if (!w || w.closed) { doc.save(pdfName()); return; } // blockerad flik → ladda ner i stället
        w.location.href = URL.createObjectURL(doc.output('blob'));
      }, function (err) { if (w) w.close(); throw err; });
    });
  }
  function previewPdf(btn) {
    if (!checkReady()) return;
    if (isMobile()) { previewPdfMobile(btn); return; }
    withBusy(btn, function () {
      return buildPdf().then(function (doc) {
        var url = URL.createObjectURL(doc.output('blob'));
        var v = document.createElement('div');
        v.className = 'eov-pdfview';
        v.innerHTML =
          '<div class="eov-pdfview__bar"><strong>Offert ' + esc(state.f.nr || '(utkast)') + '</strong>' +
          '<span class="eov-pdfview__spacer"></span>' +
          '<button type="button" class="eov-btn eov-btn--primary" data-pv-dl>Ladda ner PDF</button>' +
          '<button type="button" class="eov-btn eov-btn--ghost" data-pv-close>Stäng</button></div>' +
          '<iframe class="eov-pdfview__frame" title="Förhandsgranskning" src="' + url + '"></iframe>';
        document.body.appendChild(v);
        document.documentElement.classList.add('eov-lock');
        v.querySelector('[data-pv-dl]').addEventListener('click', function () { doc.save(pdfName()); });
        v.querySelector('[data-pv-close]').addEventListener('click', function () {
          v.remove(); document.documentElement.classList.remove('eov-lock'); URL.revokeObjectURL(url);
        });
      });
    });
  }

  /* ---------- ifyllning från offertförfrågan ----------
     Länken "Öppna i offertverktyget" i förfrågningsmejlet (#exqt=…, samma packade
     format som PDF-länken i assets/exin-quote.js). Läses av exin-quote-hash-guard. */
  function b64urlDecode(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    var bin = atob(s), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }
  function renderRequest() {
    var b = $('[data-eov-request]');
    if (!b) {
      b = document.createElement('div');
      b.className = 'eov-request no-empty';
      b.setAttribute('data-eov-request', '');
      $('.eov-top').insertAdjacentElement('afterend', b);
    }
    var q = state.request;
    if (!q) { b.hidden = true; b.innerHTML = ''; return; }
    b.hidden = false;
    b.innerHTML =
      '<div class="eov-request__body">' +
        '<strong>Från offertförfrågan ' + esc(q.ref) + '</strong>' +
        '<span>' + esc([q.date, q.company || q.name, q.email, q.phone].filter(Boolean).join(' · ')) + '</span>' +
        (q.wishes ? '<p><em>Önskemål:</em> ' + esc(q.wishes) + '</p>' : '') +
      '</div>' +
      '<button type="button" class="eov-btn eov-btn--ghost eov-btn--sm" data-eov-request-hide>Dölj</button>';
  }
  function prefillFromRequest() {
    var data = window.__exqtLinkData;
    if (!data) return;
    window.__exqtLinkData = null;
    var o;
    try { o = JSON.parse(b64urlDecode(data)); } catch (e) { toast('Kunde inte läsa förfrågan från länken.'); return; }
    var c = o.c || [];
    var name = c[0] || '', company = c[1] || '', email = c[2] || '', phone = c[3] || '';
    var hasWork = state.rows.length || state.f.lev0 || state.f.nr;
    if (hasWork && !confirm('Ersätta nuvarande utkast med offertförfrågan ' + (o.r || '') + '?')) return;
    var keepRef = state.f.varRef;
    state = defaults();
    state.f.varRef = keepRef;
    state.f.erRef = name;
    state.f.lev0 = company || name;
    state.f.sameAddr = true;
    state.f.info = ['Förfrågan ' + (o.r || ''), email, phone].filter(Boolean).join(' · ');
    state.rows = (o.i || []).map(function (a) {
      var vt = a[1] && a[1] !== 'Default Title' ? a[1] : '';
      return {
        id: uid(), img: a[6] || '', title: a[0] || '',
        desc: [vt, a[2] ? 'Art.nr ' + a[2] : '', a[5] ? 'Kommentar: ' + a[5] : ''].filter(Boolean).join('\n'),
        qty: a[4] || 1, unit: 'st', price: (a[3] || 0) / 100, disc: '',
        url: a[7] ? a[7] + (a[8] ? '?variant=' + a[8] : '') : ''
      };
    });
    state.request = { ref: o.r || '', date: o.d || '', wishes: o.w || '', name: name, company: company, email: email, phone: phone };
    save(); fillFields(); renderRows(); renderRequest();
    toast('Offertförfrågan ' + (o.r || '') + ' inläst');
  }

  /* ---------- start ---------- */
  var started = false;
  function init() {
    if (started) return; started = true;
    state = readJSON(DRAFT_KEY) || defaults();
    if (!state.f || !Array.isArray(state.rows)) state = defaults();

    var sel = $('[data-eov-sellers]');
    sel.innerHTML = '<option value="">Välj säljare…</option>' + sellers().map(function (s) { return '<option>' + esc(s) + '</option>'; }).join('');
    fillFields();
    renderRows();
    renderRequest();
    prefillFromRequest(); // länk från förfrågningsmejlet

    // Fält
    root.addEventListener('input', function (e) {
      var el = e.target;
      var k = el.getAttribute('data-f');
      if (k) {
        state.f[k] = el.type === 'checkbox' ? el.checked : el.value;
        if (/^lev\d$/.test(k) || k === 'sameAddr') syncBuyer();
        save(); return;
      }
      var rk = el.getAttribute('data-r');
      if (rk) {
        var f = findRow(el); if (!f) return;
        f.row[rk] = el.value;
        if (rk === 'desc') el.rows = Math.max(1, el.value.split('\n').length);
        f.el.querySelector('[data-r-sum]').textContent = kr(rowSum(f.row));
        renderTotals(); save(); return;
      }
      if (el.matches('[data-eov-search]')) {
        clearTimeout(searchTimer);
        var q = el.value.trim();
        searchTimer = setTimeout(function () { doSearch(q); }, 220);
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-f="sameAddr"], select[data-f]')) {
        state.f[e.target.getAttribute('data-f')] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        syncBuyer(); save();
      }
    });

    // Klick
    root.addEventListener('click', function (e) {
      var t = e.target;
      var hit = t.closest('[data-eov-hit]');
      if (hit) { pickProduct(lastResults[parseInt(hit.getAttribute('data-eov-hit'), 10)]); return; }
      var vb = t.closest('[data-eov-variant]');
      if (vb) { var box = $('[data-eov-results]'); box._add(box._variants[parseInt(vb.getAttribute('data-eov-variant'), 10)]); return; }
      if (t.closest('[data-eov-add-custom]')) {
        addRow({ title: '', desc: '', qty: 1, unit: 'st', price: 0 });
        var last = $$('.eov-row').pop(); if (last) last.querySelector('[data-r="title"]').focus();
        return;
      }
      var mv = t.closest('[data-eov-move]');
      if (mv) {
        var f = findRow(mv); if (!f) return;
        var to = f.index + parseInt(mv.getAttribute('data-eov-move'), 10);
        if (to < 0 || to >= state.rows.length) return;
        state.rows.splice(to, 0, state.rows.splice(f.index, 1)[0]); save(); renderRows(); return;
      }
      if (t.closest('[data-eov-del]')) {
        var d = findRow(t); if (!d) return;
        state.rows.splice(d.index, 1); save(); renderRows(); return;
      }
      if (t.closest('[data-eov-new]')) {
        if (!confirm('Börja på en ny offert? Det nuvarande utkastet töms.')) return;
        var keepRef = state.f.varRef;
        state = defaults(); state.f.varRef = keepRef;
        save(); fillFields(); renderRows(); renderRequest(); toast('Ny offert påbörjad'); return;
      }
      if (t.closest('[data-eov-request-hide]')) { state.request = null; save(); renderRequest(); return; }
      if (t.closest('[data-eov-pdf]')) { downloadPdf(t.closest('[data-eov-pdf]')); return; }
      if (t.closest('[data-eov-preview]')) { previewPdf(t.closest('[data-eov-preview]')); return; }
    });

    // Stäng sökresultat vid klick utanför
    document.addEventListener('click', function (e) {
      // isConnected: sökträffen som klickades kan redan ha ersatts (t.ex. av variantlistan)
      if (!e.target.isConnected || e.target.closest('.eov-search')) return;
      $('[data-eov-results]').hidden = true;
    });
    $('[data-eov-search]').addEventListener('focus', function () {
      var b = $('[data-eov-results]'); if (b.innerHTML) b.hidden = false;
    });
  }
})();
